<ng-template #changePasswordModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Change Password</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="formGroup" #form>
            <div class="col-md-12">
                <fieldset class="form-group" id="__BVID__133">
                    <div tabindex="-1" role="group"><label for="exampleEmail">Old Password</label><input
                            id="exampleEmail" name="email" type="password" placeholder="Password here..."
                            formControlName="oldPassword" for class="form-control" required>
                    </div>
                    <div *ngIf="formGroup.get('oldPassword').touched">

                        <div *ngIf="formGroup.get('oldPassword').errors?.required"
                            class="form-control-error errors m-1">
                            Please enter the old password.
                        </div>
                        <div *ngIf="formGroup.get('oldPassword').errors?.minLength"
                            class="form-control-error errors m-1">
                            atleast 6 characters required
                        </div>
                        <div *ngIf="formGroup.get('oldPassword').errors?.maxLength"
                            class="form-control-error errors m-1">
                            maximum length of the password can be 40
                        </div>
                        <div *ngIf="formGroup.get('oldPassword').errors?.pattern" class="form-control-error errors m-1">
                            password must contain one special character and number
                        </div>

                    </div>
                </fieldset>
                <fieldset class="form-group" id="__BVID__133">
                    <div tabindex="-1" role="group"><label for="exampleEmail">Password
                        </label><input id="exampleEmail" name="email" type="password"
                            placeholder="Repeat Password here..." formControlName="password" class="form-control"
                            required>
                    </div>
                    <div *ngIf="formGroup.get('password').touched">

                        <div *ngIf="formGroup.get('password').errors?.required"
                            class="form-control-error errors m-1">
                            Please enter the new password.
                        </div>
                        <div *ngIf="formGroup.get('password').errors?.minLength"
                            class="form-control-error errors m-1">
                            atleast 6 characters required
                        </div>
                        <div *ngIf="formGroup.get('password').errors?.maxLength"
                            class="form-control-error errors m-1">
                            maximum length of the password can be 40
                        </div>
                        <div *ngIf="formGroup.get('password').errors?.pattern" class="form-control-error errors m-1">
                            password must contain one special character and number
                        </div>

                    </div>
                </fieldset>
                <fieldset class="form-group" id="__BVID__133">
                    <div tabindex="-1" role="group"><label for="exampleEmail">Confirm
                            Password</label><input id="exampleEmail" name="email" type="password"
                            placeholder="Repeat Password here..." formControlName="confirmPassword" class="form-control"
                            required>
                    </div>
                    <div *ngIf="formGroup.get('confirmPassword').touched">

                        <div *ngIf="formGroup.get('confirmPassword').errors?.required"
                            class="form-control-error errors m-1">
                            Please re-enter the new password.
                        </div>
                        <div *ngIf="formGroup.get('confirmPassword').errors?.minLength"
                            class="form-control-error errors m-1">
                            atleast 6 characters required
                        </div>
                        <div *ngIf="formGroup.get('confirmPassword').errors?.maxLength"
                            class="form-control-error errors m-1">
                            maximum length of the password can be 40
                        </div>
                        <div *ngIf="formGroup.get('confirmPassword').errors?.pattern" class="form-control-error errors m-1">
                            password must contain one special character and number
                        </div>

                    </div>
                    <h6 class="mb-12">Password Policy:</h6>
                    <div class="mt-12 d-flex align-items-center">
                      
                      Your password may be any combination of 6  to 40 letters ,numbers and special characters 
                      <br>* It is case sensitive
                      <br>* At least one Upper case
                      <br>* At least one Lower case
                      <br>* At least one Number case
                      <br>* At least one special characters from the folowing : @ $ ! % * ? &
                  </div>
                </fieldset>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click')">Cancel</button>
        <!-- <button *ngIf="editMode" [disabled]="!addUserForm.valid" type="button" class="btn btn-primary"
            (click)="saveUser()">Update</button>-->
        <button *ngIf="!editMode" [disabled]="!formGroup.valid" type="button" class="btn btn-success"
            (click)="changePassword()">Change Password</button> 
    </div>
    <app-loading *ngIf="loading"></app-loading>
</ng-template>